import { withStyles } from '@material-ui/core';

import ConfirmModal from './component';
import styles from './styles';

export default withStyles(styles)(ConfirmModal);
